import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import SystemUtilities from "../../system-utilities"
import { Observable, Subscription } from 'rxjs';
import { SystemSiteService } from '../../services/system-site.service';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
declare interface TableData {
  headerRow: string[];
  dataRows: string[][];
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  Data: any = [];
  site_data: any;
  processed_data: any = [];
  selectable_databases: any = [];
  ModalData: any = {};
  loading: boolean = true;
  downloading: boolean = true;
  closeResult: string;
  search_practice_number: string = ''; //0115339
  selected_database: string = "";
  selected_user_object: any = {};
  selected_username_id: string = "";
  selected_username: string = "";
  reset_password_flag: boolean = false;
  selected_reset_method: string = "email";
  modalReference: any;
  loginSubscription: Subscription = null;
  downloadSubscription: Subscription = null;
  resetPasswordSubscription: Subscription = null;
  downloadFileSubscription: Subscription = null;
  download_url: string = `${environment.site_URL}`;
  public result_message = ""
  constructor(private modalService: NgbModal, private systemSiteService: SystemSiteService, private router: Router) { }



  ngOnInit() {


    this.LoadData();




  }


  LoadData() {
    this.downloadSubscription = this.systemSiteService.get_downloads("software").subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.Data = data.result_data;
        this.loading = false;
      },
      error: (error) => { console.log(error) },
    })
  }




  async open(content, type) {
    if (type === 'sm') {
      console.log('aici');
      this.modalService.open(content, { size: 'sm' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {


      console.log(this.search_practice_number)

      this.processed_data = [];

      this.site_data = [];

      this.loginSubscription = this.systemSiteService.get_practice(this.search_practice_number).subscribe({
        next: (data) => {



          this.site_data = data.result_data;
          //console.log(this.site_data)
          if (this.site_data.length == 0) {
            this.result_message = "Practice not found!"
            return;
          }

          for (let pratice_data of this.site_data) {

            //console.log(pratice_data)0

            let user_object = {};
            user_object["_id"] = pratice_data._id;
            user_object["pracnumber"] = pratice_data.pracnumber;
            user_object["username"] = pratice_data.firstname + " " + pratice_data.lastname;
            if (pratice_data.dremail != null) {

              user_object["dremail"] = new SystemUtilities().maskEmail(pratice_data.dremail.split('/')[0]);
              try {

                if (pratice_data.drcell != null) {

                  user_object["drcell"] = new SystemUtilities().maskPhoneNumber(pratice_data.drcell);

                }
                else {

                  user_object["drcell"] = "000#######"

                }
              } catch (error) {

                user_object["drcell"] = "000#######"
              }


              user_object["databases"] = [];
              user_object["user_id"] = pratice_data["@unid"];

              if (Array.isArray(pratice_data.databasefilenames)) {
                for (let db of pratice_data.databasefilenames) {

                  user_object["databases"].push({ database: db.split('~')[0], database_name: db.split('~')[1] });

                }
              }
              else {
                this.selected_username = pratice_data._id
                user_object["pracnumber"] = pratice_data.pracnumber;
                user_object["databases"] = [{ database: pratice_data.databasefilenames.split('~')[0], database_name: pratice_data.databasefilenames.split('~')[1] }];

              }

              this.processed_data.push(user_object)

            }
            else {
              this.result_message = "Doctor Recovery Email not set!"
              return;
            }


          }


          this.selected_user_object = this.processed_data[0]
          this.selected_database = this.selected_user_object['databases'][0]['database']
          this.selected_username_id = this.selected_user_object["_id"]
          this.selected_username = this.selected_user_object["username"]


          this.result_message = "Practice found!"

          this.modalService.open(content).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
            if (`${result}` === 'Continue') {
              let url = "https://emdmix001.e-md.co.za/" + this.selected_database + "/cloud?OpenForm&login&username=" + encodeURIComponent(this.selected_user_object.username) + "&password=";
              console.log(url)
              window.location.href = url;

            }
            this.result_message = ""
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

          });


          this.loading = false;
        },
        error: (error) => { },
      })


    }
  }


  get_user_databases_on_change(event) {


    const searchIndex = this.processed_data.findIndex((user) => user._id == this.selected_username_id);

    this.selected_user_object = this.processed_data[searchIndex]

    console.log(this.search_practice_number)
  }


  reset_password(event) {

    this.reset_password_flag = true;

  }


  async reset_password_submit(event) {

    this.reset_password_flag = true;

    let user_data = JSON.stringify({
      "user_id": this.selected_user_object.user_id,
      "type": this.selected_reset_method
    });



    this.resetPasswordSubscription = this.systemSiteService.reset_password_request_otp(user_data).subscribe({
      next: async (data) => {
        console.log(data.result_data);
        this.loading = true;

        let result_data = data.result_data;

        if (result_data['UserVerifyResult'] == null) {
          console.log("Could not send OTP!");
        } else {



          this.modalService.dismissAll();
          this.router.navigate(['/reset_password', this.selected_user_object.user_id]);
          //refirect to pin
        }


      },
      error: (error) => { console.log(error); },
    })


    console.log(this.selected_user_object.user_id)

  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // downloadFile(id) {
  //   return this.downloadSubscription = this.systemSiteService.get_download_file(id).subscribe({
  //     next: (data) => {
  //       let file_name = "dummy_file.pdf";
  //       saveAs(data, file_name);
  //       return { 'data': { 'message': 'download success' } };
  //     },
  //     error: (error) => { console.log(error) },
  //   })

  // }





  downloadFile(id: string, filename: string, mimetype: string, download_url: string): void {

    const link = document.createElement('a');
    link.href = download_url;
    link.download = filename
    link.type = mimetype
    //link.setAttribute('download', `${filename}`);  // Adjust the file extension/name as needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);



    // this.systemSiteService.get_download_file(id).subscribe(data => {
    //   const blob = new Blob([data], { type: mimetype });  // Adjust the MIME type as needed
    //   const url = window.URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', `${filename}`);  // Adjust the file extension/name as needed
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    //   this.downloading = false;


    //   this.modalReference.close();

    // });



  }

  ngOnDestroy(): void {
    if (this.loginSubscription)
      this.loginSubscription.unsubscribe();
    if (this.downloadSubscription)
      this.downloadSubscription.unsubscribe();
    if (this.downloadSubscription)
      this.downloadSubscription.unsubscribe();
    if (this.resetPasswordSubscription)
      this.resetPasswordSubscription.unsubscribe();
    if (this.downloadFileSubscription)
      this.downloadFileSubscription.unsubscribe();
  }




}
